import PAIR_API_V3_ABI from './pairApiV3.json'

const PAIR_API_V3_ADDRESS = '0x7a01bef660c7137EA7c23F2B61c77Ceee1Bd8863'
export { PAIR_API_V3_ADDRESS, PAIR_API_V3_ABI }
